export default {
  // Page meta
  'latestAttack.page.title': 'All Matrix Attacks Defeated | All Systems Are Back Online',
  'latestAttack.page.description': 'TateProtest.com and the official @TateProtest account on X are back online. Both appeals succeeded and every system has been restored.',

  // Hero
  'latestAttack.hero.kicker': 'ALL SYSTEMS ONLINE',
  'latestAttack.hero.title': 'All Matrix Attacks Defeated',
  'latestAttack.hero.subtitle': 'All Systems Are Back Online',

  // Attack section
  'latestAttack.attack.title': 'They Tried to Silence Us—They Failed',
  'latestAttack.attack.p1': 'Tate Protest has successfully defeated every attempt made against our platforms. TateProtest.com and the official @TateProtest account on X are back online. On August 18, TateProtest.com was temporarily shut down after its hosting provider received reports falsely accusing the website of doxxing. Approximately 12 hours later, the website was restored.',
  'latestAttack.attack.deny': 'Our X account was also suspended following similar reports. We immediately appealed the decision, explained that Tate Protest had not engaged in doxxing, and successfully regained access to the account.',
  'latestAttack.attack.p2': 'Both appeals succeeded. Every system has been restored.',
  'latestAttack.attack.appeal': 'We believe these reports were designed to interfere with our lawful advocacy as the August 27 protest approaches. Those we describe as “Matrix agents” appear willing to do anything they can to disrupt our message—but false reports and temporary suspensions will not stop this movement.',
  'latestAttack.attack.p3': 'We will continue exercising our rights peacefully, responsibly, and within the law.',
  'latestAttack.attack.p4': 'Tate Protest does not support doxxing, threats, harassment, or violence.',

  // Timeline labels
  'latestAttack.timeline.title': 'Restoration Timeline',
  'latestAttack.timeline.morning': 'August 18 — Website Offline',
  'latestAttack.timeline.morningDesc': 'TateProtest.com temporarily shut down after false doxxing reports',
  'latestAttack.timeline.afternoon': '~12 Hours Later',
  'latestAttack.timeline.afternoonDesc': 'TateProtest.com restored and returned online',
  'latestAttack.timeline.evening': 'X Account Suspended',
  'latestAttack.timeline.eveningDesc': 'The official @TateProtest account suspended following similar reports',
  'latestAttack.timeline.now': 'All Systems Online',
  'latestAttack.timeline.nowDesc': 'Both appeals succeeded — every system has been restored',

  // Events section
  'latestAttack.events.title': 'The Events Are Still Happening',
  'latestAttack.events.intro': 'These temporary disruptions have not changed our plans.',
  'latestAttack.events.reunion.label': 'TATE PROTEST GET-TOGETHER',
  'latestAttack.events.reunion.date': 'Wednesday, August 26, 2026 · 7:00 PM',
  'latestAttack.events.protest.label': 'MIAMI COURTHOUSE PROTEST',
  'latestAttack.events.protest.date': 'Thursday, August 27, 2026 · 9:00 AM',
  'latestAttack.events.protest.venue': 'C. Clyde Atkins U.S. Courthouse',
  'latestAttack.events.protest.address': '301 North Miami Avenue, Miami, Florida 33128',
  'latestAttack.events.protest.guidance': 'The protest will be peaceful and lawful. Everyone attending should respect courthouse rules, remain on publicly permitted property, and avoid obstructing entrances or pedestrian traffic.',
  'latestAttack.events.protest.hearingStart': 'begins at {{time}}.',

  // Closing section
  'latestAttack.closing.title': 'We Are Still Here',
  'latestAttack.closing.p1': 'They reported the website. It came back. They suspended the X account. We won the appeal. They tried to disrupt the movement. The movement became stronger.',
  'latestAttack.closing.p2': 'All Matrix attacks have been defeated. All systems are back online. We now move forward toward August 26 and August 27—peacefully, lawfully, and more united than ever.',
  'latestAttack.closing.p3': 'Peaceful. Lawful. More united than ever.',
  'latestAttack.closing.hashtags': '#TateProtest #FreeTheTates #AllSystemsOnline #WeWillNotBeSilenced',

  // Back link
  'latestAttack.back': '← Back to Home',
};
